import { ArticleSearchObject } from '~/services/search/config/articles/types';
import { ProductSearchObject } from '~/services/search/config/products/types';

import { ProviderSearchResults } from '../types';
import { RESULTS_LIMIT } from './consts';
import { initializeSearch } from './initializeSearch';
import { ArticleSearchRawObject, ProductSearchRawObject } from './types';

const isArticleSearchDocument = (
  searchResult: ArticleSearchRawObject | ProductSearchRawObject
): searchResult is ArticleSearchRawObject =>
  searchResult.meta.type === 'article';

const isProductSearchDocument = (
  searchResult: ArticleSearchRawObject | ProductSearchRawObject
): searchResult is ProductSearchRawObject =>
  searchResult.meta.type === 'product';

export const executeSearch = async (
  searchQuery: string,
  locale: string
): Promise<ProviderSearchResults> => {
  await initializeSearch(locale);

  const pagefind = await import('static/pagefind/pagefind');
  const search = await pagefind.search(searchQuery);
  const searchResult = await Promise.all(
    search.results.slice(0, RESULTS_LIMIT).map((result) => result.data())
  );

  const articles: Array<ArticleSearchObject> = [];
  const products: Array<ProductSearchObject> = [];

  searchResult?.forEach((data) => {
    if (isArticleSearchDocument(data)) {
      const result: ArticleSearchObject = {
        url: data.meta.url,
        title: data.meta.title,
        description: data.meta.description,
        seo_description: data.meta.seo_description,
        seo_keywords: JSON.parse(data.meta.seo_keywords),
        seo_title: data.meta.seo_title,
        id: data.meta.id,
        lang: data.meta.lang,
        type: 'article',
      };
      articles.push(result);
    }

    if (isProductSearchDocument(data)) {
      const result: ProductSearchObject = {
        id: data.meta.id,
        url: data.meta.url,
        title: data.meta.title,
        description: data.meta.description,
        seo_description: data.meta.seo_description,
        seo_keywords: JSON.parse(data.meta.seo_keywords),
        seo_title: data.meta.seo_title,
        sku: data.meta.sku,
        lang: data.meta.lang,
        image_data: data.meta.image_data,
        image_title: data.meta.image_title,
        image_url: data.meta.image_url,
        aroma_scent: data.meta.aroma_scent,
        net_content_statement: data.meta.aroma_scent,
        brand_name: JSON.parse(data.meta.brand_name),
        barcode_number: data.meta.barcode_number,
        segment_description: data.meta.segment_description,
        type: 'product',
      };
      products.push(result);
    }
  });

  return {
    articles,
    products,
  };
};
